import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import dayjs, { Dayjs } from 'dayjs';

dayjs.extend(utc);
dayjs.extend(timezone);

const shortDateTimeFormat = 'HH:mm DD.MM';

const getDefaultTournamentStart = () => {
  return dayjs().hour(8).minute(0).second(0).millisecond(0);
};

/**
 * Checks if the given date is in the future relative to now.
 */
const isFuture = (date: string) => {
  return dayjs().isBefore(date);
};

const getDiffFromDateToNow = (date: string) => {
  const diff = dayjs(date).diff(undefined, 'minutes');
  if (diff <= 2) {
    return dayjs(date).diff(undefined, 'seconds') + ' sek.';
  }
  return diff + ' min.';
};

const getDiffInMillisFromDateToNow = (date: string) => {
  return dayjs(date).diff();
};

const getShortDateFormatWithDayOfWeek = (date: string) => {
  return dayjs(date).locale('pl').format('dddd DD.MM.YYYY');
};

const getShortDateTimeFormat = (date?: string, utc?: boolean) => {
  if (utc) {
    return dayjs.utc(date).local().format(shortDateTimeFormat);
  }
  return dayjs(date).format(shortDateTimeFormat);
};

const transformDate = (orgDate: string | Dayjs) => {
  const formattedDate = dayjs(orgDate).format('YYYY-MM-DDTHH:mm:ss');
  if (formattedDate !== orgDate) {
    console.log(`Transformed date from ${orgDate} -> ${formattedDate}`);
  }
  return formattedDate;
};

const getDateFromDateTime = (dateTime: string) => {
  return dateTime.split('T')[0];
};

const getTimeFromDateTime = (dateTime: string) => {
  return dateTime.split('T')[1];
};

export {
  getDefaultTournamentStart,
  isFuture,
  getDiffFromDateToNow,
  getDiffInMillisFromDateToNow,
  getShortDateFormatWithDayOfWeek,
  getShortDateTimeFormat,
  transformDate,
  getDateFromDateTime,
  getTimeFromDateTime,
};
